import axios from "axios";

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL, // Use an environment variable or a default value
  timeout: 10000, // 10 seconds timeout
});

apiClient.interceptors.request.use(
  (config) => {
    // Add Authorization token dynamically (if available)
    const token = localStorage.getItem("authToken"); // Or retrieve it from a global state/store
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Modify other headers dynamically if needed
    config.headers["Content-Type"] = "application/json";

    return config;
  },
  (error) => {
    // Handle request error
    console.error("Request error:", error);
    return Promise.reject(error);
  }
);

apiClient.interceptors.response.use(
  (response) => {
    // You can modify the response here if needed
    return response;
  },
  (error) => {
    // Handle response errors globally
    if (error.response) {
      // Server responded with a status outside the 2xx range
      console.error("Response error:", error.response);

      // Example: Handle Unauthorized (401) globally
      if (error.response.status === 401) {
        // alert("Session expired. Please log in again.");
        // window.location.href = "/sign-in"; // Redirect to login page
      }
    } else if (error.request) {
      // No response was received
      console.error("No response received:", error.request);
    } else {
      // Something happened while setting up the request
      console.error("Error setting up request:", error.message);
    }

    return Promise.reject(error);
  }
);

export default apiClient;
